import { Router } from "@angular/router";

export const toollist =  [
    {
        "Type": "Button",
        "Label": "previous",
        "Color": "special",
        "Icon": "skip_previous",
        "Method": "previousIndicator"
    },
    {
        "Type": "Button",
        "Label": "next",
        "Color": "special",
        "Icon": "skip_next",
        "Method": "nextIndicator"
    },
    {
        "Type": "Button",
        "Label": "Sommaire",
        "Color": "primary",
        "Icon": "menu_book",
        "Method": "toggleSummary"
    },
    {
        "Type": "Button",
        "Label": "Mode d'emploi",
        "Color": "danger",
        "Icon": "help",
        "Method": "toggleManual"
    },
    {
        "Type": "Button",
        "Label": "Auto-remplissage",
        "Color": "primary",
        "Icon": "auto_fix_high",
        "Method": "autofill",
        "Condition": "isAdmin"
    },
    {
        "Type": "Button",
        "Label": "Retour",
        "Color": "disabled",
        "Icon": "arrow_back_ios",
        "Method": "saveAndGoBack"
    },
    {
        "Type": "Button",
        "Label": "Terminer",
        "Color": "basic",
        "Icon": "arrow_forward_ios",
        "Method": "saveAndGotoReport"
    },

]